<script setup>
import { formatPLN } from "~/utils/format.js";
const props = defineProps({
  supportRate: { type: Number, required: true },
  oneTimeSubtotal: { type: Number, required: true },
  recurringSubtotal: { type: Number, required: true },
  supportFee: { type: Number, required: true },
  domainCost: { type: Number, required: true },
  serverCost: { type: Number, required: true },
  sslCost: { type: Number, required: true },
  firstYearTotal: { type: Number, required: true },
});

defineExpose({
  getSummaryEmailHtml,
});

const copyForEmailRef = ref(null);

function getSummaryEmailHtml() {
  return copyForEmailRef.value.formatForEmail();
}
</script>

<template>
  <CopyForEmail ref="copyForEmailRef">
    <div
      style="
        border-radius: 0.75rem;
        border: 1px solid #e5e7eb;
        background-color: #ffffff;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
        overflow: hidden;
      "
    >
      <div
        style="
          padding-left: 1.25rem;
          padding-right: 1.25rem;
          padding-top: 1rem;
          padding-bottom: 1rem;
          border-bottom: 1px solid #f3f4f6;
        "
      >
        <h3
          style="font-size: 1rem; line-height: 1.5rem; font-weight: 600; color: #111827"
        >
          Podsumowanie
        </h3>
      </div>

      <div
        style="
          padding-left: 1.25rem;
          padding-right: 1.25rem;
          padding-top: 1rem;
          padding-bottom: 1rem;
          font-size: 0.875rem;
          line-height: 1.25rem;
        "
      >
        <div style="display: flex; align-items: center; justify-content: space-between">
          <span style="color: #4b5563">Suma jednorazowa</span>
          <span style="font-weight: 600">{{ formatPLN(oneTimeSubtotal) }}</span>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #4b5563">Koszty roczne</span>
          <span style="font-weight: 600">{{ formatPLN(recurringSubtotal) }}</span>
        </div>

        <div
          style="
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 0.75rem;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #374151; margin-left: 0.5rem">
            Utrzymanie i wsparcie ({{ Math.round(supportRate * 100) }}%/rok)
          </span>
          <span style="font-weight: 600">{{ formatPLN(supportFee) }}</span>
        </div>

        <div
          style="
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 0.75rem;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #374151; margin-left: 0.5rem">Domena</span>
          <span style="font-weight: 600">{{ formatPLN(domainCost) }}</span>
        </div>

        <div
          style="
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 0.75rem;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #374151; margin-left: 0.5rem">Serwer</span>
          <span style="font-weight: 600">{{ formatPLN(serverCost) }}</span>
        </div>

        <div
          style="
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 0.75rem;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #374151; margin-left: 0.5rem">Certyfikat SSL</span>
          <span style="font-weight: 600">{{ formatPLN(sslCost) }}</span>
        </div>

        <hr style="margin-top: 0.75rem; margin-bottom: 0.5rem" />

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #1f2937; font-weight: 500">Razem pierwszy rok</span>
          <span style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 700">
            {{ formatPLN(firstYearTotal) }}
          </span>
        </div>

        <div
          style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 0.75rem;
          "
        >
          <span style="color: #1f2937; font-weight: 500">Kolejne lata / rok</span>
          <span style="font-size: 1.125rem; line-height: 1.75rem; font-weight: 700">
            {{ formatPLN(recurringSubtotal) }}
          </span>
        </div>
      </div>
    </div>
  </CopyForEmail>
</template>
